<template>
  <CFlex inline v-tooltip="getExecutionStatusLabel(status)">
    <CIcon :name="icon"/>
    <CExecutionStatusIcon :status/>
  </CFlex>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CFlex from '@/shared/components/CFlex.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import ExecutionStatus from '../constants/ExecutionStatus';
  import { getExecutionStatusLabel } from '../utils/labels';
  import CExecutionStatusIcon from './CExecutionStatusIcon.vue';

  const props = defineProps<{
    status: ExecutionStatus;
  }>();

  const icon = computed(() => {
    switch (props.status) {
      case ExecutionStatus.NOT_GIVEN:
      case ExecutionStatus.REQUESTED_EXECUTION:
      case ExecutionStatus.EXECUTE:
      case ExecutionStatus.DO_NOT_EXECUTE:
        return 'wrench';
      case ExecutionStatus.REQUESTED_DIAGNOSIS:
      case ExecutionStatus.EXECUTE_DIAGNOSIS:
      case ExecutionStatus.DO_NOT_DIAGNOSE:
        return 'search-eye';
    }
  });
</script>